import UrlGeneration from '@lovata/url-generation';

export default class ListPagination {
  constructor(obListHelper = null) {
    this.obListHelper = obListHelper;
    this.sEventType = 'click';
    this.sFiledName = 'page';
    this.sAttributeName = 'data-page';

    this.sDefaultButtonClass = '_js-pagination';
    this.sButtonSelector = `.${this.sDefaultButtonClass}`;
  }

  init() {
    $(document).on(this.sEventType, this.sButtonSelector, (obEvent) => {
      obEvent.preventDefault();
      obEvent.stopPropagation();

      const obButton = $(obEvent.currentTarget);
      const iPage = obButton.attr(this.sAttributeName);

      UrlGeneration.init();
      if (iPage === 1) {
        UrlGeneration.remove(this.sFiledName);
      } else {
        UrlGeneration.set(this.sFiledName, [iPage]);
      }

      UrlGeneration.update();
      if (!this.obListHelper) {
        return;
      }

      this.obListHelper.send();
    });
  }

  setButtonSelector(sButtonSelector) {
    this.sButtonSelector = sButtonSelector;

    return this;
  }
}
